<div
  [class]="iconClasses()"
  [style.color]="color()"
  [attr.aria-label]="name()"
  role="img"
>
  @if (isLoading()) {
    <div class="v-one-icon__loading">
      <div class="v-one-icon__spinner"></div>
    </div>
  } @else if (hasError()) {
    <div class="v-one-icon__error">
      <span>?</span>
    </div>
  } @else if (svgContent()) {
    <div class="v-one-icon__content" [innerHTML]="svgContent()"></div>
  }
</div>
